<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    checkDisabled('pending') ||
                      user.role.roleName == 'FINANCE_MANAGER'
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                    @change="calculateAllDueDate()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('pending')"
                >
                  <v-text-field
                    slot="activator"
                    label="Est. Arrival Date"
                    type="text"
                    prepend-icon="event"
                    v-model="estArrivalDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="estArrivalDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="purchaseOrder.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="purchaseOrder.warehouseId"
                  :items="activeWarehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  @change="
                    (purchaseOrder.procurementPlanNo = null),
                      (purchaseOrder.procurementPlanId = null)
                  "
                  :readonly="
                    checkDisabled('pending') ||
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'SALE_MANAGER' ||
                      user.role.roleName == 'GENERAL_MANAGER' ||
                      user.role.roleName == 'FINANCE_MANAGER' ||
                      user.role.roleName == 'BRANCH_ADMIN' ||
                      user.role.roleName == 'WAREHOUSE_STAFF' ||
                      (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                        user.warehouseId)||
                      user.role.roleName == 'ASSET_MANAGER'
                  "
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="Order Year"
                  label="Order Year"
                  v-model="purchaseOrder.orderYear"
                  type="text"
                  :readonly="checkDisabled('pending')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="Procurement Plan No"
                  label="Procurement Plan No"
                  v-model="purchaseOrder.procurementPlanNo"
                  type="text"
                  readonly
                  :disabled="
                    purchaseOrder.warehouseId && checkDisabled('pending')
                  "
                  @click="showProcurementPlanDialog"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="purchaseOrder.purchaseType"
                  :items="purchaseTypeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Purchase Type..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  @change="changePurchaseType"
                  :readonly="status != 'တင်ပြရန်ကျန်'"
                  :rules="rules.purchaseTypeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="purchaseOrder.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status == 'ဝယ်ယူပြီးစီးမှု'"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="purchaseOrder.description"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="purchaseOrder.remark"
                  type="text"
                  :rules="rules.remarkRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="purchaseOrder.id">
                <v-text-field
                  label="Created Date"
                  v-model="createdDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="purchaseOrder.id">
                <v-text-field
                  label="Created By"
                  v-model="purchaseOrder.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="purchaseOrder.id">
                <v-text-field
                  label="Updated Date"
                  v-model="updatedDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="purchaseOrder.id">
                <v-text-field
                  label="Updated By"
                  v-model="purchaseOrder.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <!--<v-flex xs12 ml-2 mt-1>
                <v-switch
                  v-model="isItemDiscount"
                  inset
                  :label="'discount'"
                  @change="toggleDiscount"
                  :disabled="
                    status == 'ဝယ်ယူပြီးစီးမှု'
                  "
                ></v-switch>
              </v-flex>-->
              <v-flex sm12>
                <v-label>Attach File</v-label>
                <input
                  type="file"
                  id="files"
                  ref="files"
                  v-on:change="onChangeFileUpload"
                  multiple
                  accept=".pdf, .png, .jpg, .jpeg, .docx, .xlsx"
                />
              </v-flex>
              <v-flex sm12>
                <div v-for="(poAttachment, key) in poAttachments" :key="key">
                  <a
                    v-text="poAttachment.fileName"
                    @click.prevent="downloadFile(poAttachment)"
                  />
                  <span v-if="purchaseOrder.id">
                    <v-btn icon @click="removeFile(key, poAttachment.id)">
                      <v-icon color="red">cancel</v-icon>
                    </v-btn>
                  </span>
                </div>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showProducts()"
                    :disabled="
                      checkDisabled('pending') ||
                        user.role.roleName == 'FINANCE_MANAGER'
                    "
                  >
                    Add Current Asset Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs5 ml-4 mr-3 mt-2>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      :loading="barcodeLoading"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="
                        checkDisabled('pending') ||
                          user.role.roleName == 'FINANCE_MANAGER'
                      "
                    ></v-text-field>
                  </v-flex>
                  <div class="font-weight-bold">
                    <span>Total Net Cost:</span>
                    <v-chip>
                      <span>{{ totalPOAmount | decFormat(6) }}</span>
                    </v-chip>
                    <br />
                    <span>Total Net Cost (MMK):</span>
                    <v-chip>
                      <span>{{ totalPOMMKAmount | decFormat(6) }}</span>
                    </v-chip>
                  </div>
                </v-layout>

                <!-- detail table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailNameSearch"
                        append-icon="search"
                        placeholder="Enter product name"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.productCode }}</td>
                      <td>{{ props.item.productName }}</td>
                      <td>{{ props.item.supplierName }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.currencyExchangeMMK }}</td>
                      <td>{{ props.item.factorUnitName }}</td>
                      <td>{{ props.item.qty | decFormat(6) }}</td>
                      <td>
                        {{ Number(props.item.actualUnitCost) | decFormat(6) }}
                      </td>
                      <td>
                        {{ Number(props.item.unitCostMMK) | decFormat(6) }}
                      </td>
                      <!-- total cost -->
                      <td>
                        {{
                          (props.item.qty * props.item.unitCost) | decFormat(6)
                        }}
                      </td>
                      <!-- total cost mmk -->
                      <td>
                        {{
                          (props.item.qty * props.item.unitCostMMK)
                            | decFormat(6)
                        }}
                      </td>
                      <td>{{ props.item.sellingPrice }}</td>
                      <td>{{ props.item.countryName }}</td>
                      <td>{{ props.item.approveNo }}</td>
                      <td>
                        {{
                          props.item.approveDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>
                        {{ props.item.dueDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td>
                        {{
                          props.item.arrivalDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>
                        {{
                          props.item.tenderStartDateInMilliSeconds
                            | formatMsDate
                        }}
                      </td>
                      <td>
                        {{
                          props.item.tenderEndDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>{{ props.item.tenderQty | decFormat(6) }}</td>
                      <td>{{ props.item.tenderCommittee }}</td>
                      <td>{{ props.item.tenderEC }}</td>
                      <td>{{ props.item.remark }}</td>
                      <td class="px-0">
                        <v-btn
                          color="primary"
                          @click="onShowDetail(props.item)"
                          :disabled="props.item.isNew"
                        >
                          Detail
                        </v-btn>
                      </td>
                      <!-- actions -->
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editDetail(props.item)"
                            :disabled="checkDisabled('finish')"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removePurchaseOrderItem(props.item.id)"
                            :disabled="
                              checkDisabled('pending') ||
                                user.role.roleName == 'FINANCE_MANAGER'
                            "
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showAssets()"
                    :disabled="
                      checkDisabled('pending') ||
                        user.role.roleName == 'FINANCE_MANAGER'
                    "
                  >
                    Add Fixed Asset Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>

                <!-- detail table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailAssetSearch"
                        append-icon="search"
                        placeholder="Enter Asset Name"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailAssetHeaders"
                    :items="assetDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.assetName }}</td>
                      <td>{{ props.item.supplierName }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.exchangeRate }}</td>
                      <td>{{ props.item.unitName }}</td>
                      <td>{{ props.item.qty | decFormat(6) }}</td>
                      <td>
                        {{ Number(props.item.actualUnitCost) | decFormat(6) }}
                      </td>
                      <td>
                        {{ Number(props.item.unitCostMMK) | decFormat(6) }}
                      </td>
                      <!-- total cost -->
                      <td>
                        {{
                          (props.item.qty * props.item.unitCost) | decFormat(6)
                        }}
                      </td>
                      <!-- total cost mmk -->
                      <td>
                        {{
                          (props.item.qty * props.item.unitCostMMK)
                            | decFormat(6)
                        }}
                      </td>
                      <td>{{ props.item.sellingPrice }}</td>
                      <td>{{ props.item.countryName }}</td>
                      <td>{{ props.item.approveNo }}</td>
                      <td>
                        {{
                          props.item.approveDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>
                        {{ props.item.dueDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td>
                        {{
                          props.item.arrivalDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>
                        {{
                          props.item.tenderStartDateInMilliSeconds
                            | formatMsDate
                        }}
                      </td>
                      <td>
                        {{
                          props.item.tenderEndDateInMilliSeconds | formatMsDate
                        }}
                      </td>
                      <td>{{ props.item.tenderQty | decFormat(6) }}</td>
                      <td>{{ props.item.tenderCommittee }}</td>
                      <td>{{ props.item.tenderEC }}</td>
                      <td>{{ props.item.remark }}</td>
                      <!-- actions -->
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editAssetDetail(props.item)"
                            :disabled="checkDisabled('finish')"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removePurchaseOrderAsset(props.item.id)"
                            :disabled="
                              checkDisabled('pending') ||
                                user.role.roleName == 'FINANCE_MANAGER'
                            "
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="checkDisabled('finish')"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="saveLoading || checkDisabled('finish')"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
      v-model="purchaseOrderItemDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Purchase Order Item</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="detailForm" v-model="detailValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="productCode"
                  label="Product Code"
                  v-model="selectedPurchaseOrderItem.productCode"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="productName"
                  label="Product Name"
                  v-model="selectedPurchaseOrderItem.productName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderItem.factorUnitName"
                  :hide-no-data="true"
                  :items="selectedPurchaseOrderItem.productUnits"
                  color="blue-grey lighten-2"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  @change="(option) => initPrice(option)"
                  :readonly="checkDisabled('pending')"
                  :rules="rules.unitRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderItem.supplierId"
                  :items="supplierList"
                  color="blue-grey lighten-2"
                  label="Choose Supplier..."
                  item-text="companyName"
                  menu-props="auto"
                  item-value="id"
                  :loading="supplierListLoading"
                  @change="changeSupplier"
                  :readonly="checkDisabled('pending')"
                  :rules="rules.supplierRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderItem.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                  @change="changeCurrency"
                  :readonly="checkDisabled('pending')"
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="currencyExchangeMMK"
                  label="Exchange Rate"
                  v-model="selectedPurchaseOrderItem.currencyExchangeMMK"
                  min="1"
                  type="number"
                  :loading="supplierProductLoading"
                  :error-messages="supplierProductError"
                  @input="changeActualUnitCost(selectedPurchaseOrderItem)"
                  :rules="rules.purchasedExchangeRateMMKRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCost"
                  label="Unit Cost"
                  v-model="selectedPurchaseOrderItem.actualUnitCost"
                  type="number"
                  :rules="rules.unitCostRules"
                  :loading="supplierProductLoading"
                  :error-messages="supplierProductError"
                  @input="changeActualUnitCost(selectedPurchaseOrderItem)"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCostMMK"
                  label="Unit Cost(MMK)"
                  v-model="selectedPurchaseOrderItem.unitCostMMK"
                  type="number"
                  :rules="rules.unitCostMMKRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="sellingPrice"
                  label="Selling Price"
                  v-model="selectedPurchaseOrderItem.sellingPrice"
                  type="number"
                  :rules="rules.sellingPriceRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="selectedPurchaseOrderItem.qty"
                  type="number"
                  :rules="rules.qtyRules"
                  :readonly="checkDisabled('pending')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderItem.countryId"
                  :items="countryList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Country Of Origin..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="approveNo"
                  label="Approve No"
                  v-model="selectedPurchaseOrderItem.approveNo"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finished')"
                >
                  <v-text-field
                    slot="activator"
                    label="Approve Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderItem.approveDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderItem.approveDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  disabled
                >
                  <v-text-field
                    slot="activator"
                    label="Due Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderItem.dueDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderItem.dueDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Arrival Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderItem.arrivalDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderItem.arrivalDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Tender Start Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderItem.tenderStartDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderItem.tenderStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Tender End Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderItem.tenderEndDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderItem.tenderEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="tenderQty"
                  label="Tender Qty"
                  v-model="selectedPurchaseOrderItem.tenderQty"
                  type="number"
                  :rules="rules.tenderQtyRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="tenderCommittee"
                  label="Tender Committee"
                  v-model="selectedPurchaseOrderItem.tenderCommittee"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="tenderEC"
                  label="Tender EC"
                  v-model="selectedPurchaseOrderItem.tenderEC"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="selectedPurchaseOrderItem.remark"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="closePurchaseOrderItemDialog">
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!detailValid"
                    @click="addPurchaseOrderItem"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="purchaseOrderAssetDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Purchase Order Asset</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="detailAssetForm"
            v-model="detailAssetValid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Asset Name"
                  label="Asset Name"
                  v-model="selectedPurchaseOrderAsset.assetName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Unit Name"
                  label="Unit Name"
                  v-model="selectedPurchaseOrderAsset.unitName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderAsset.supplierId"
                  :items="assetSupplierList"
                  color="blue-grey lighten-2"
                  label="Choose Supplier..."
                  item-text="companyName"
                  menu-props="auto"
                  item-value="id"
                  :readonly="checkDisabled('pending')"
                  @change="
                    changeAssetSupplier(selectedPurchaseOrderAsset.supplierId)
                  "
                  :rules="rules.supplierRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderAsset.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                  :readonly="checkDisabled('pending')"
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="exchangeRate"
                  label="Exchange Rate"
                  v-model="selectedPurchaseOrderAsset.exchangeRate"
                  min="1"
                  type="number"
                  @input="changeAssetUnitCost(selectedPurchaseOrderAsset)"
                  :rules="rules.exchangeRateRules('exchange rate')"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCost"
                  label="Unit Cost"
                  v-model="selectedPurchaseOrderAsset.actualUnitCost"
                  type="number"
                  :rules="rules.unitCostRules"
                  @input="changeAssetUnitCost(selectedPurchaseOrderAsset)"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCostMMK"
                  label="Unit Cost(MMK)"
                  v-model="selectedPurchaseOrderAsset.unitCostMMK"
                  type="number"
                  :rules="rules.unitCostMMKRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="sellingPrice"
                  label="Selling Price"
                  v-model="selectedPurchaseOrderAsset.sellingPrice"
                  type="number"
                  :rules="rules.sellingPriceRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="selectedPurchaseOrderAsset.qty"
                  type="number"
                  :rules="rules.qtyRules"
                  :readonly="checkDisabled('pending')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-autocomplete
                  v-model="selectedPurchaseOrderAsset.countryId"
                  :items="countryList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Country Of Origin..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="approveNo"
                  label="Approve No"
                  type="text"
                  v-model="selectedPurchaseOrderAsset.approveNo"
                  :rules="rules.lengthRules(255, 'Approve no')"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Approve Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderAsset.approveDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderAsset.approveDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  disabled
                >
                  <v-text-field
                    slot="activator"
                    label="Due Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderAsset.dueDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderAsset.dueDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Arrival Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderAsset.arrivalDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderAsset.arrivalDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Tender Start Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderAsset.tenderStartDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderAsset.tenderStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="checkDisabled('finish')"
                >
                  <v-text-field
                    slot="activator"
                    label="Tender End Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedPurchaseOrderAsset.tenderEndDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedPurchaseOrderAsset.tenderEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="tenderQty"
                  label="Tender Qty"
                  v-model="selectedPurchaseOrderAsset.tenderQty"
                  type="number"
                  :rules="rules.tenderQtyRules"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="tenderCommittee"
                  label="Tender Committee"
                  type="text"
                  v-model="selectedPurchaseOrderAsset.tenderCommittee"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="tenderEC"
                  label="Tender EC"
                  type="text"
                  v-model="selectedPurchaseOrderAsset.tenderEC"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  type="text"
                  v-model="selectedPurchaseOrderAsset.remark"
                  :rules="rules.lengthRules(500, 'Remark')"
                  :readonly="checkDisabled('finish')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="
                      purchaseOrderAssetDialog = !purchaseOrderAssetDialog
                    "
                  >
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!detailAssetValid"
                    @click="addPurchaseOrderAsset"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="headers"
              :items="productList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setProduct(props.item.code),
                      (showProductListDialog = !showProductListDialog)
                  "
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.brand.name }}</td>
                <td>{{ props.item.category.name }}</td>
                <td v-if="props.item.productGroup">
                  {{ props.item.productGroup.name }}
                </td>
                <td v-else></td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Asset List Dialog -->
    <v-dialog v-model="showAssetListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Asset name"
                type="text"
                class="mr-1"
                v-model="queryParamsAssets.assetName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="type"
                label="Asset Type"
                type="text"
                class="mr-1"
                v-model="queryParamsAssets.assetType"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchAsset">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Asset List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="assetHeaders"
              :items="depreciationList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="assetPagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setAsset(props.item.assetName),
                      (showAssetListDialog = !showAssetListDialog)
                  "
                >
                  <a>{{ props.item.assetName }}</a>
                </td>
                <td>{{ props.item.assetType }}</td>
                <td>{{ props.item.cost }}</td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Procurement Plan Dialog -->
    <v-dialog v-model="showPlanListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="planQueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="planQueryParams.fromDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="planQueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="planQueryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="planQueryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Description"
                label="Description"
                type="text"
                v-model="planQueryParams.description"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex sm3>
              <v-select
                :items="planStatusList"
                label="Status"
                item-text="label"
                item-value="value"
                v-model="planQueryParams.status"
              ></v-select>
            </v-flex> -->
            <v-flex sm3>
              <v-select
                :items="planTypeList"
                label="Type"
                item-text="label"
                item-value="value"
                v-model="planQueryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchPlan">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="planHeaders"
              :items="procurementPlanList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="planPagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
                <td @click="setProcurementPlan(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.status }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- error message dialog -->
    <v-dialog
      v-model="errorMessageBox"
      max-width="500px"
      @keydown.enter="closeErrMsgBox"
      @keydown.esc="closeErrMsgBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeErrMsgBox"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end error message dialog -->

    <PurchaseOrderItemDetailDialog
      :show-dialog="showPoItemDetailDialog"
      :poItem="selectedPurchaseOrderItem"
      @close="showPoItemDetailDialog = false"
    ></PurchaseOrderItemDetailDialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import { purchaseOrderService } from "../../services/purchase-order-service";
import { supplierService } from "../../services/supplier-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import {
  PurchaseOrder,
  PurchaseOrderAsset,
  PurchaseOrderItem,
} from "../../models/model";
import { PurchaseOrderFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { procurementPlanService } from "../../services/procurement-plan-service";
import { currencyService } from "../../services/currency-service";
import PurchaseOrderItemDetailDialog from "../purchase-order/PurchaseOrderItemDetailDialog.vue";
import { assetService } from "../../services/asset-service";
import { countryService } from "../../services/country-service";

export default {
  name: "PurchaseOrderDetail",
  components: { VSwitch, PurchaseOrderItemDetailDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    detailValid: true,
    detailAssetValid: true,
    breadcrumbs: [
      {
        text: "Purchase Order(Asset)",
        disabled: false,
        to: "purchase-order-assets",
      },
      {
        text: "Purchase Order(Asset) Detail",
        disabled: true,
      },
    ],
    issueDate: "",
    estArrivalDate: "",
    purchaseOrder: new PurchaseOrder(),
    oldpurchaseOrder: new PurchaseOrder(),
    purchaseOrderItem: new PurchaseOrderItem(),
    selectedPurchaseOrderItem: new PurchaseOrderItem(),
    purchaseOrderAsset: new PurchaseOrderAsset(),
    selectedPurchaseOrderAsset: new PurchaseOrderAsset(),
    rules: new PurchaseOrderFormRules(),
    responseError: "",
    purchaseOrderItemDialog: false,
    purchaseOrderAssetDialog: false,
    saveLoading: false,
    activeWarehouseList: [],
    tempList: [],
    countryList: [],
    productUnitList: [],
    depreciationList: [],
    currencyList: [],
    defaultCurrencyId: "",
    productList: [],
    supplierList: [],
    assetSupplierList: [],
    supplierListLoading: false,
    isItemDiscount: false,
    purchaseTypeList: [],
    statusList: ["တင်ပြရန်ကျန်"],
    status: "တင်ပြရန်ကျန်",
    showProductListDialog: false,
    showAssetListDialog: false,
    showPlanListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    assetHeaders: [
      { text: "Asset Name", value: "assetName", sortable: false },
      { text: "Asset Type", value: "assetType", sortable: false },
      { text: "Cost", value: "cost", sortable: false },
      { text: "Description", value: "description", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    assetPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "assetName",
      totalItems: 0,
    },
    planPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "issueDate",
      totalItems: 0,
    },
    totalRows: 0,
    updatedDate: "",
    createdDate: "",
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    planQueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      planYear: "",
      type: "",
      warehouseId: "",
      status: "PENDING",
      description: "",
      isAddDetails: true,
      qtyLimit: "LESS",
      procurementPlanType: "ASSET",
    },
    queryParamsAssets: {
      assetName: "",
      assetType: "",
      shopCode: "",
      statusList: ["DRAFT", "CONFIRM"],
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedId: 0,
    totalPOAmount: 0,
    files: [],
    poAttachments: [],
    procurementPlanList: [],
    scanBarcode: "",
    barcodeLoading: false,
    errorMessageBox: false,
    totalPOMMKAmount: 0,
    planHeaders: [
      {
        text: "Issue Date",
        align: "left",
        value: "issueDate",
        sortable: false,
      },
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Warehouse", value: "warehouse" },
      { text: "Description", value: "description" },
      { text: "Status", value: "status", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    planStatusList: [
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
    ],
    planTypeList: [
      { label: "ALL", value: "" },
      { label: "စက်ရုံBOD", value: "စက်ရုံBOD" },
      { label: "ရုံးချုပ်BOD", value: "ရုံးချုပ်BOD" },
      { label: "ဝယ်ကော်", value: "ဝယ်ကော်" },
      { label: "တင်ဒါပြည်တွင်း", value: "တင်ဒါပြည်တွင်း" },
      { label: "တင်ဒါပြည်ပ", value: "တင်ဒါပြည်ပ" },
      { label: "Other", value: "Other" },
    ],
    detailHeaders: [
      { text: "Code", sortable: false },
      { text: "Product", sortable: false },
      { text: "Supplier", sortable: false },
      { text: "Currency", sortable: false },
      { text: "Exchange Rate", align: "center", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Qty", align: "center", sortable: false },
      { text: "Unit Cost", align: "center", sortable: false },
      { text: "Unit Cost(MMK)", align: "center", sortable: false },
      { text: "Total Cost", align: "center", sortable: false },
      { text: "Total Cost(MMK)", align: "center", sortable: false },
      { text: "Selling Price", align: "center", sortable: false },
      { text: "Country Of Origin", sortable: false },
      { text: "Approve No", sortable: false },
      { text: "Approve Date", sortable: false },
      { text: "Due Date", sortable: false },
      { text: "Arrival Date", sortable: false },
      { text: "Tender Start Date", sortable: false },
      { text: "Tender End Date", sortable: false },
      { text: "Tender Qty", align: "center", sortable: false },
      { text: "Tender Committee", sortable: false },
      { text: "Tender EC", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Detail", align: "center", sortable: false },
      { text: "Action", sortable: false },
    ],
    detailAssetHeaders: [
      { text: "Asset Name", sortable: false },
      { text: "Supplier", sortable: false },
      { text: "Currency", sortable: false },
      { text: "Exchange Rate", align: "center", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Qty", align: "center", sortable: false },
      { text: "Unit Cost", align: "center", sortable: false },
      { text: "Unit Cost(MMK)", align: "center", sortable: false },
      { text: "Total Cost", align: "center", sortable: false },
      { text: "Total Cost(MMK)", align: "center", sortable: false },
      { text: "Selling Price", align: "center", sortable: false },
      { text: "Country Of Origin", sortable: false },
      { text: "Approve No", sortable: false },
      { text: "Approve Date", sortable: false },
      { text: "Due Date", sortable: false },
      { text: "Arrival Date", sortable: false },
      { text: "Tender Start Date", sortable: false },
      { text: "Tender End Date", sortable: false },
      { text: "Tender Qty", align: "center", sortable: false },
      { text: "Tender Committee", sortable: false },
      { text: "Tender EC", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    detailCodeSearch: "",
    detailNameSearch: "",
    detailAssetSearch: "",
    supplierProductError: "",
    supplierProductLoading: false,
    showPoItemDetailDialog: false,
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    planPagination: {
      handler() {
        this.getProcurementPlanList();
      },
      deep: true,
    },
  },

  computed: {
    detailList() {
      return this.purchaseOrder.purchaseOrderItems.filter((d) => {
        if (this.detailCodeSearch && this.detailNameSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1 &&
            d.productName
              .toLowerCase()
              .indexOf(this.detailNameSearch.toLowerCase()) > -1
          );
        else if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else if (this.detailNameSearch)
          return (
            d.productName
              .toLowerCase()
              .indexOf(this.detailNameSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
    assetDetailList() {
      return this.purchaseOrder.purchaseOrderAssets.filter((d) => {
        if (this.detailAssetSearch)
          return (
            d.assetName
              .toLowerCase()
              .indexOf(this.detailAssetSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },

  created() {
    this.getAllSupplier();
    this.getActiveWarehouseList();
    this.getCurrencies();
    this.getAllPurchaseTypes();
    this.getActiveCountry();

    //this.toggleDiscount();
    const id = this.$route.params.id;
    if (id == "new") {
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        this.purchaseOrder.warehouseId = this.user.warehouseId;
        this.queryParams.warehouseId = this.user.warehouseId;
      }
      if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER"||
        this.user.roleName == "ASSET_MANAGER"
      ) {
        this.purchaseOrder.warehouseId = this.user.shop.warehouseId;
        this.queryParams.warehouseId = this.user.shop.warehouseId;
        this.queryParamsAssets.shopCode = this.user.shop.code;
      }
    } else {
      this.getPurchaseOrderDetail(id);
      this.getProductList();
    }
  },

  methods: {
    getAllSupplier() {
      supplierService
        .getAllSupplier()
        .then((res) => {
          this.assetSupplierList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCurrencies() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          let currency = commonService.search(
            "defaultCurrency",
            true,
            this.currencyList
          );
          if (currency) this.defaultCurrencyId = currency.id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllPurchaseTypes() {
      purchaseOrderService
        .getAllPurchaseTypes("ASSET")
        .then((res) => {
          let tempList = res.data;
          tempList.forEach((temp) => {
            this.purchaseTypeList.push({ label: temp, value: temp });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    onSearchAsset() {
      this.queryParamsAssets.page = this.assetPagination.page;
      this.queryParamsAssets.size = this.assetPagination.rowsPerPage;
      this.getAssetList();
    },
    onSearchPlan() {
      this.planQueryParams.page = this.planPagination.page;
      this.planQueryParams.size = this.planPagination.rowsPerPage;
      this.getProcurementPlanList();
    },
    getSuppliersByProductId(productId) {
      this.supplierListLoading = true;
      supplierService
        .getSuppliersByProductId(productId)
        .then((res) => {
          this.supplierList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.supplierListLoading = false;
        });
    },
    getWarehouseList() {
      var temp;
      var tempWarehouseList = [];
      temp = this.purchaseOrder.warehouse.name;
      if (!this.tempList.includes(temp)) {
        this.tempList.push(temp);
        tempWarehouseList.push(this.purchaseOrder.warehouse);
      }

      for (var j = 0; j < this.activeWarehouseList.length; j++) {
        temp = this.activeWarehouseList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempWarehouseList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempWarehouseList;
    },
    goBack() {
      this.$router.go(-1);
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.purchaseOrder.purchaseOrderItems.find(
          (d) => d.id == id
        );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    addPurchaseOrderItem() {
      if (this.$refs.detailForm.validate()) {
        // deep copy
        let poItem = JSON.parse(JSON.stringify(this.selectedPurchaseOrderItem));

        let supplier = this.supplierList.find((s) => s.id == poItem.supplierId);
        if (supplier) poItem.supplierName = supplier.companyName;

        let currency = this.currencyList.find((c) => c.id == poItem.currencyId);
        if (currency) poItem.currencyCode = currency.code;

        if (poItem.countryId) {
          let country = this.countryList.find(
            (ct) => ct.id == poItem.countryId
          );
          if (country) poItem.countryName = country.name;
        } else {
          poItem.countryName = "";
        }

        if (poItem.arrivalDate) {
          poItem.arrivalDateInMilliSeconds = commonService.convertToMilliseconds(
            poItem.arrivalDate
          );
        }
        if (poItem.approveDate) {
          poItem.approveDateInMilliSeconds = commonService.convertToMilliseconds(
            poItem.approveDate
          );
        }
        if (poItem.tenderStartDate) {
          poItem.tenderStartDateInMilliSeconds = commonService.convertToMilliseconds(
            poItem.tenderStartDate
          );
        }
        if (poItem.tenderEndDate) {
          poItem.tenderEndDateInMilliSeconds = commonService.convertToMilliseconds(
            poItem.tenderEndDate
          );
        }
        const index = this.purchaseOrder.purchaseOrderItems
          .map((d) => d.id)
          .indexOf(poItem.id);
        if (index > -1) {
          this.purchaseOrder.purchaseOrderItems.splice(index, 1, poItem);
        } else {
          this.purchaseOrder.purchaseOrderItems.unshift(poItem);
        }
        this.closePurchaseOrderItemDialog();
        this.calculateTotalPOAmount();
      }
    },
    getActiveCountry() {
      countryService
        .getCountryByStatus("ACTIVE")
        .then((res) => {
          this.countryList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addPurchaseOrderAsset() {
      if (this.$refs.detailAssetForm.validate()) {
        // deep copy
        let poAsset = JSON.parse(
          JSON.stringify(this.selectedPurchaseOrderAsset)
        );

        let supplier = this.assetSupplierList.find(
          (s) => s.id == poAsset.supplierId
        );
        if (supplier) poAsset.supplierName = supplier.companyName;

        let currency = this.currencyList.find(
          (c) => c.id == poAsset.currencyId
        );
        if (currency) poAsset.currencyCode = currency.code;

        if (poAsset.countryId) {
          let country = this.countryList.find(
            (ct) => ct.id == poAsset.countryId
          );
          if (country) poAsset.countryName = country.name;
        } else {
          poAsset.countryName = "";
        }

        if (poAsset.arrivalDate) {
          poAsset.arrivalDateInMilliSeconds = commonService.convertToMilliseconds(
            poAsset.arrivalDate
          );
        }
        if (poAsset.approveDate) {
          poAsset.approveDateInMilliSeconds = commonService.convertToMilliseconds(
            poAsset.approveDate
          );
        }
        if (poAsset.dueDate) {
          poAsset.dueDateInMilliSeconds = commonService.convertToMilliseconds(
            poAsset.dueDate
          );
        }
        if (poAsset.tenderStartDate) {
          poAsset.tenderStartDateInMilliSeconds = commonService.convertToMilliseconds(
            poAsset.tenderStartDate
          );
        }
        if (poAsset.tenderEndDate) {
          poAsset.tenderEndDateInMilliSeconds = commonService.convertToMilliseconds(
            poAsset.tenderEndDate
          );
        }
        const index = this.purchaseOrder.purchaseOrderAssets
          .map((d) => d.id)
          .indexOf(poAsset.id);
        if (index > -1) {
          this.purchaseOrder.purchaseOrderAssets.splice(index, 1, poAsset);
        } else {
          this.purchaseOrder.purchaseOrderAssets.unshift(poAsset);
        }
        this.purchaseOrderAssetDialog = !this.purchaseOrderAssetDialog;
        this.calculateTotalPOAmount();
      }
    },
    changeActualUnitCost(poItem) {
      if (this.isItemDiscount) {
        let discount = poItem.actualUnitCost * (poItem.discountPercent / 100);
        discount = parseFloat(discount).toFixed(6);
        poItem.unitCost = poItem.actualUnitCost - discount;
        poItem.unitCost = parseFloat(poItem.unitCost).toFixed(6);
      } else {
        poItem.unitCost = poItem.actualUnitCost;
      }

      poItem.unitCostMMK = poItem.unitCost * poItem.currencyExchangeMMK;
      poItem.unitCostMMK = Number(parseFloat(poItem.unitCostMMK).toFixed(6));

      poItem.basicUnitCost = poItem.actualUnitCost / poItem.factor;
    },
    closePurchaseOrderItemDialog() {
      this.purchaseOrderItemDialog = !this.purchaseOrderItemDialog;
    },
    editDetail(poItem) {
      this.getSuppliersByProductId(poItem.productId);

      this.selectedPurchaseOrderItem = JSON.parse(JSON.stringify(poItem));

      // set approved date
      if (poItem.arrivalDateInMilliSeconds)
        this.selectedPurchaseOrderItem.arrivalDate = commonService.millisecondToDate(
          Number(poItem.arrivalDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      if (poItem.approveDateInMilliSeconds)
        this.selectedPurchaseOrderItem.approveDate = commonService.millisecondToDate(
          Number(poItem.approveDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set tender start date
      if (poItem.tenderStartDateInMilliSeconds)
        this.selectedPurchaseOrderItem.tenderStartDate = commonService.millisecondToDate(
          Number(poItem.tenderStartDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set tender end date
      if (poItem.tenderEndDateInMilliSeconds)
        this.selectedPurchaseOrderItem.tenderEndDate = commonService.millisecondToDate(
          Number(poItem.tenderEndDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set due date
      if (poItem.dueDateInMilliSeconds)
        this.selectedPurchaseOrderItem.dueDate = commonService.millisecondToDate(
          Number(poItem.dueDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      this.purchaseOrderItemDialog = true;
    },
    editAssetDetail(poItem) {
      this.selectedPurchaseOrderAsset = JSON.parse(JSON.stringify(poItem));

      // set approved date
      if (poItem.arrivalDateInMilliSeconds)
        this.selectedPurchaseOrderAsset.arrivalDate = commonService.millisecondToDate(
          Number(poItem.arrivalDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      if (poItem.approveDateInMilliSeconds)
        this.selectedPurchaseOrderAsset.approveDate = commonService.millisecondToDate(
          Number(poItem.approveDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set tender start date
      if (poItem.tenderStartDateInMilliSeconds)
        this.selectedPurchaseOrderAsset.tenderStartDate = commonService.millisecondToDate(
          Number(poItem.tenderStartDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set tender end date
      if (poItem.tenderEndDateInMilliSeconds)
        this.selectedPurchaseOrderAsset.tenderEndDate = commonService.millisecondToDate(
          Number(poItem.tenderEndDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      // set due date
      if (poItem.dueDateInMilliSeconds)
        this.selectedPurchaseOrderAsset.dueDate = commonService.millisecondToDate(
          Number(poItem.dueDateInMilliSeconds),
          "YYYY-MM-DD"
        );

      this.purchaseOrderAssetDialog = true;
    },
    removePurchaseOrderItem(purchaseOrderItemId) {
      const index = this.purchaseOrder.purchaseOrderItems
        .map((d) => d.id)
        .indexOf(purchaseOrderItemId);

      if (!this.purchaseOrder.purchaseOrderItems[index].isNew) {
        // add delete purchaseOrderItem id
        if (!this.purchaseOrder.deletePurchaseOrderItemIds) {
          this.purchaseOrder.deletePurchaseOrderItemIds = [];
        }
        this.purchaseOrder.deletePurchaseOrderItemIds.push(purchaseOrderItemId);
      }
      this.$delete(this.purchaseOrder.purchaseOrderItems, index);
      this.calculateTotalPOAmount();
    },
    removePurchaseOrderAsset(purchaseOrderAssetId) {
      const index = this.purchaseOrder.purchaseOrderAssets
        .map((d) => d.id)
        .indexOf(purchaseOrderAssetId);

      if (!this.purchaseOrder.purchaseOrderAssets[index].isNew) {
        // add delete purchaseOrderItem id
        if (!this.purchaseOrder.deletePurchaseOrderAssetIds) {
          this.purchaseOrder.deletePurchaseOrderAssetIds = [];
        }
        this.purchaseOrder.deletePurchaseOrderAssetIds.push(
          purchaseOrderAssetId
        );
      }
      this.$delete(this.purchaseOrder.purchaseOrderAssets, index);
      this.calculateTotalPOAmount();
    },
    getPurchaseOrderDetail(id) {
      purchaseOrderService
        .getPurchaseOrderDetail(id)
        .then((res) => {
          this.purchaseOrder = res.data;
          this.isItemDiscount = this.purchaseOrder.isItemDiscount;
          this.purchaseOrder.warehouse = this.purchaseOrder.warehouseDTO;

          this.poAttachments = res.data.poAttachments;
          this.status = this.purchaseOrder.status;
          this.changePurchaseType(this.purchaseOrder.purchaseType);

          this.issueDate = commonService.millisecondToDate(
            this.purchaseOrder.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          if (this.purchaseOrder.estArrivalDateInMilliSeconds != null) {
            this.estArrivalDate = commonService.millisecondToDate(
              this.purchaseOrder.estArrivalDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }

          this.createdDate = commonService.millisecondToDate(
            this.purchaseOrder.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.purchaseOrder.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (res.data.country) {
            this.countryList.push(res.data.country);
          }
          // deep copy
          this.oldpurchaseOrder = JSON.parse(JSON.stringify(res.data));
          this.getWarehouseList();
          this.calculateTotalPOAmount();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          //convert to millisecond
          this.purchaseOrder.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );
          if (this.estArrivalDate) {
            this.purchaseOrder.estArrivalDateInMilliSeconds = commonService.convertToMilliseconds(
              this.estArrivalDate
            );
          }
          // deep copy and remove unecessary objects
          let purchaseOrder = JSON.parse(JSON.stringify(this.purchaseOrder));
          purchaseOrder.warehouse = null;
          purchaseOrder.warehouseDTO = null;
          purchaseOrder.purchaseOrderItems.forEach((detail) => {
            detail.productUnits = null;
            if (detail.isNew) detail.id = null;
          });

          purchaseOrder.purchaseOrderAssets.forEach((detail) => {
            if (detail.isNew) detail.id = null;
          });
          purchaseOrder.purchaseOrderType = "ASSET";
          purchaseOrderService
            .savePurchaseOrderAsset(purchaseOrder)
            .then((res) => {
              if (res) {
                // this.goBack();
                this.purchaseOrder.id = res.data.id;
                this.saveFiles(this.purchaseOrder.id);
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.selectedPurchaseOrderItem.productUnits
      );

      this.selectedPurchaseOrderItem.productUnitId = productUnit.id;
      this.selectedPurchaseOrderItem.actualUnitCost = productUnit.unitCost.toFixed(
        6
      );
      this.changeActualUnitCost(this.selectedPurchaseOrderItem);
      this.selectedPurchaseOrderItem.factor = productUnit.factor;
      this.selectedPurchaseOrderItem.sellingPrice = productUnit.sellingPrice.toFixed(
        6
      );
      this.selectedPurchaseOrderItem.discountPercent =
        productUnit.unitCostPercentage;
      this.getSupplierProduct();
    },
    changeSupplier(supplierId) {
      if (supplierId) this.getSupplierProduct();
    },
    changeCurrency(currencyId) {
      if (currencyId) this.getSupplierProduct();
    },
    changeAssetSupplier(supplierId) {
      let supplier = this.assetSupplierList.find((v) => v.id == supplierId);
      if (supplier) {
        this.selectedPurchaseOrderAsset.dueDateInMilliSeconds = this.calculateDueDate(
          supplier.periodDays
        );
        this.selectedPurchaseOrderAsset.periodDays = supplier.periodDays;
        if (this.selectedPurchaseOrderAsset.dueDateInMilliSeconds)
          this.selectedPurchaseOrderAsset.dueDate = commonService.millisecondToDate(
            Number(this.selectedPurchaseOrderAsset.dueDateInMilliSeconds),
            "YYYY-MM-DD"
          );
      }
    },
    calculateDueDate(periodDays) {
      let dueDateInMilliSeconds = "";
      if (periodDays > 0) {
        periodDays = periodDays - 1;
      }
      if (this.issueDate) {
        dueDateInMilliSeconds =
          Number(commonService.convertToMilliseconds(this.issueDate)) +
          periodDays * 24 * 60 * 60 * 1000;
      }
      return dueDateInMilliSeconds;
    },
    calculateAllDueDate() {
      this.purchaseOrder.purchaseOrderItems.forEach(
        (v) => (v.dueDateInMilliSeconds = this.calculateDueDate(v.periodDays))
      );
      this.purchaseOrder.purchaseOrderAssets.forEach(
        (v) => (v.dueDateInMilliSeconds = this.calculateDueDate(v.periodDays))
      );
    },
    getSupplierProduct() {
      var supplierId = this.selectedPurchaseOrderItem.supplierId;
      var productId = this.selectedPurchaseOrderItem.productId;
      var productUnitId = this.selectedPurchaseOrderItem.productUnitId;
      var currencyId = this.selectedPurchaseOrderItem.currencyId;

      if (supplierId && productId && productUnitId && currencyId) {
        let params = {
          supplierId: supplierId,
          productId: productId,
          productUnitId: productUnitId,
          currencyId: currencyId,
        };
        this.supplierProductError = "";
        this.supplierProductLoading = true;
        supplierService
          .getSupplierProduct(params)
          .then((res) => {
            if (res.data) {
              this.selectedPurchaseOrderItem.dueDateInMilliSeconds = this.calculateDueDate(
                res.data.periodDays
              );
              this.selectedPurchaseOrderItem.periodDays = res.data.periodDays;
              if (this.selectedPurchaseOrderItem.dueDateInMilliSeconds)
                this.selectedPurchaseOrderItem.dueDate = commonService.millisecondToDate(
                  Number(this.selectedPurchaseOrderItem.dueDateInMilliSeconds),
                  "YYYY-MM-DD"
                );
              this.selectedPurchaseOrderItem.currencyExchangeMMK =
                res.data.exchangeRate;
              this.selectedPurchaseOrderItem.actualUnitCost = res.data.unitCost;
              this.changeActualUnitCost(this.selectedPurchaseOrderItem);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.supplierProductLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.purchaseOrder.id) {
        this.purchaseOrder = new PurchaseOrder();
        this.purchaseOrder.warehouseId = this.user.warehouseId;
      } else {
        this.purchaseOrder = Object.assign({}, this.oldpurchaseOrder);
        this.purchaseOrder.warehouseId = this.oldpurchaseOrder.warehouseId;
        this.isItemDiscount = this.purchaseOrder.isItemDiscount;
      }
    },
    getProductList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.productList = [];
      let order = this_.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this_.queryParams,
          this_.pagination.page,
          this_.pagination.rowsPerPage,
          this_.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this_.productList = res.data.productList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },
    showProcurementPlanDialog() {
      this.planQueryParams.warehouseId = this.purchaseOrder.warehouseId;
      this.getProcurementPlanList().then(() => {
        this.showPlanListDialog = !this.showPlanListDialog;
      });
    },
    getProcurementPlanList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.procurementPlanList = [];
      let order = this_.planPagination.descending ? "desc" : "asc";
      return procurementPlanService
        .getProcurementPlanList(
          this_.planQueryParams,
          this_.planPagination.page,
          this_.planPagination.rowsPerPage,
          this_.planPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this_.procurementPlanList = res.data.procurementPlanList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },
    getAssetList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return assetService
        .getAssetList(
          this.queryParamsAssets,
          this.assetPagination.page,
          this.assetPagination.rowsPerPage,
          this.assetPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.depreciationList = res.data.assetList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    showAssets() {
      // Clean query params
      this.queryParamsAssets.assetName = "";
      this.queryParamsAssets.assetType = "";
      let warehouse = this.activeWarehouseList.find(v => v.id = this.purchaseOrder.warehouseId);
      if (warehouse) {
        this.queryParamsAssets.shopCode = warehouse.shopCode;
      }
      this.depreciationList = [];
      this.getAssetList().then(
        (this.showAssetListDialog = !this.showAssetListDialog)
      );
    },
    /*toggleDiscount() {
      if (this.isItemDiscount) {
        this.purchaseOrder.purchaseOrderItems.forEach((element) => {
          let discount = element.unitCost * (element.discountPercent / 100);
          discount = parseFloat(discount).toFixed(6);
          element.unitCost = parseFloat(element.unitCost - discount).toFixed(6);
        });
        this.purchaseOrder.isItemDiscount = true;
      } else {
        this.purchaseOrder.purchaseOrderItems.forEach((element) => {
          element.unitCost = element.actualUnitCost;
        });
        this.purchaseOrder.isItemDiscount = false;
      }
      this.purchaseOrder.purchaseOrderItems.forEach((element) => {
        element.sellingPrice = element.sellingPrice;
      });
      this.calculateTotalPOAmount();
    },*/
    setProduct(code) {
      let product = commonService.search("code", code, this.productList);

      this.getSuppliersByProductId(product.id);

      this.selectedPurchaseOrderItem = new PurchaseOrderItem();

      // if no id, add temporary id for key
      if (!this.selectedPurchaseOrderItem.id) {
        this.selectedPurchaseOrderItem.isNew = true;
        this.selectedPurchaseOrderItem.id = this.generateId();
      }
      this.selectedPurchaseOrderItem.productId = product.id;
      this.selectedPurchaseOrderItem.productCode = product.code;
      this.selectedPurchaseOrderItem.productName = product.name;

      // set default unit
      var j = 0;
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.selectedPurchaseOrderItem.productUnitId = product.productUnits[j].id;
      this.selectedPurchaseOrderItem.factorUnitName =
        product.productUnits[j].factorUnitName;
      this.selectedPurchaseOrderItem.factor = product.productUnits[j].factor;
      this.selectedPurchaseOrderItem.productUnits = product.productUnits;
      this.selectedPurchaseOrderItem.qty = product.productUnits[j].qty;
      this.selectedPurchaseOrderItem.actualUnitCost =
        product.productUnits[j].unitCost;
      this.changeActualUnitCost(this.selectedPurchaseOrderItem);
      this.selectedPurchaseOrderItem.discountPercent =
        product.productUnits[j].unitCostPercentage;
      this.selectedPurchaseOrderItem.sellingPrice = product.productUnits[
        j
      ].sellingPrice.toFixed(6);

      this.selectedPurchaseOrderItem.currencyId = this.defaultCurrencyId;

      this.purchaseOrderItemDialog = !this.purchaseOrderItemDialog;
    },
    setAsset(assetName) {
      let asset = commonService.search(
        "assetName",
        assetName,
        this.depreciationList
      );
      this.selectedPurchaseOrderAsset = new PurchaseOrderAsset();

      // if no id, add temporary id for key
      if (!this.selectedPurchaseOrderAsset.id) {
        this.selectedPurchaseOrderAsset.isNew = true;
        this.selectedPurchaseOrderAsset.id = this.generateId();
      }

      this.selectedPurchaseOrderAsset.assetId = asset.id;
      this.selectedPurchaseOrderAsset.assetName = asset.assetName;
      this.selectedPurchaseOrderAsset.unitId = asset.unitId;
      this.selectedPurchaseOrderAsset.unitName = asset.unitName;
      this.selectedPurchaseOrderAsset.qty = 0.0;
      this.selectedPurchaseOrderAsset.actualUnitCost = asset.purchaseAmount;
      this.selectedPurchaseOrderAsset.unitCost = asset.purchaseAmount;
      this.selectedPurchaseOrderAsset.unitCostMMK = asset.purchaseAmount;
      this.selectedPurchaseOrderAsset.discountPercent = 0;
      this.selectedPurchaseOrderAsset.sellingPrice = asset.purchaseAmount;
      this.selectedPurchaseOrderAsset.currencyId = this.defaultCurrencyId;
      this.purchaseOrderAssetDialog = !this.purchaseOrderAssetDialog;
    },
    calculateTotalPOAmount() {
      this.totalPOAmount = 0;
      this.totalPOMMKAmount = 0;
      this.purchaseOrder.purchaseOrderItems.forEach((p) => {
        this.totalPOAmount += p.qty * p.unitCost;
        this.totalPOMMKAmount += p.qty * p.unitCostMMK;
      });
      this.purchaseOrder.purchaseOrderAssets.forEach((p)=> {
        this.totalPOAmount += p.qty * p.unitCost;
        this.totalPOMMKAmount += p.qty * p.unitCostMMK;
      });
    },
    onChangeFileUpload(e) {
      this.responseError = "";
      var size = 0;
      this.files = e.target.files;
      if (this.files) {
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size / 1024 / 1024;
        }
      }
      if (size > 30) {
        this.responseError =
          "Upload file size exceeds the maximun upload size!";
      }
    },
    saveFiles(id) {
      if (this.files) {
        this.saveLoading = true;
        let formData = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          console.log(file);
          formData.append("file", file);
        }
        purchaseOrderService
          .saveFiles(formData, id)
          .then((res) => {
            this.goBack();
            this.done();
            console.log(res.data);
          })
          .catch((err) => {
            if (err.response) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },
    removeFile(index, fileId) {
      if (fileId) {
        if (!this.purchaseOrder.deletePOAttachmentIds) {
          this.purchaseOrder.deletePOAttachmentIds = [];
        }
        this.purchaseOrder.deletePOAttachmentIds.push(fileId);
      }
      this.$delete(this.purchaseOrder.poAttachments, index);
    },
    downloadFile(file) {
      purchaseOrderService
        .downloadFile(file.id)
        .then(commonService.downloadE)
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    trigger(barcode) {
      if (barcode) {
        this.barcodeLoading = true;
        let params = {
          barcode: barcode,
          isPurchase: true,
        };
        productService
          .getProductUnitByBarcode(params)
          .then((res) => {
            let productUnit = res.data;
            if (productUnit) {
              this.selectedPurchaseOrderItem = new PurchaseOrderItem();

              // add temporary id for key
              this.selectedPurchaseOrderItem.isNew = true;
              this.selectedPurchaseOrderItem.id = this.generateId();

              let product = productUnit.product;
              this.selectedPurchaseOrderItem.productId = product.id;
              this.selectedPurchaseOrderItem.productCode = product.code;
              this.selectedPurchaseOrderItem.productName = product.name;
              this.selectedPurchaseOrderItem.productUnitId = productUnit.id;
              this.selectedPurchaseOrderItem.productUnits[0] = productUnit;
              this.selectedPurchaseOrderItem.factorUnitName =
                productUnit.factorUnitName;
              this.selectedPurchaseOrderItem.factor = productUnit.factor;

              this.selectedPurchaseOrderItem.actualUnitCost =
                productUnit.unitCost;
              this.changeActualUnitCost(this.selectedPurchaseOrderItem);
              this.selectedPurchaseOrderItem.discountPercent =
                productUnit.unitCostPercentage;
              this.selectedPurchaseOrderItem.sellingPrice = productUnit.sellingPrice.toFixed(
                6
              );

              this.selectedPurchaseOrderItem.currencyId = this.defaultCurrencyId;
              this.purchaseOrderItemDialog = true;
            }
          })
          .catch((err) => {
            console.error(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.errorMessageBox = true;
            }
          })
          .finally(() => {
            this.scanBarcode = "";
            this.barcodeLoading = false;
          });
      }
    },
    closeErrMsgBox() {
      this.errorMessageBox = false;
      this.responseError = "";
    },
    onShowDetail(poItem) {
      this.selectedPurchaseOrderItem = JSON.parse(JSON.stringify(poItem));
      this.showPoItemDetailDialog = true;
    },
    onShowAssetDetail(poAsset) {
      this.selectedPurchaseOrderAsset = JSON.parse(JSON.stringify(poAsset));
      this.showPoItemDetailDialog = true;
    },
    changePurchaseType(purchaseType) {
      if (this.purchaseOrder.id)
        this.statusList = this.getStatusList(purchaseType);
    },
    getStatusList(purchaseType) {
      if (this.status == "တင်ပြရန်ကျန်") {
        if (purchaseType == "စက်ရုံBOD" || purchaseType == "ရုံးချုပ်BOD") {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: false },
            {
              label: "ခွင့်ပြုချက်စောင့်",
              value: "ခွင့်ပြုချက်စောင့်",
              disabled: false,
            },
          ];
        } else {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: false },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: false,
            },
          ];
        }
      } else if (this.status == "ခွင့်ပြုချက်စောင့်") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "ခွင့်ပြုချက်စောင့်",
            value: "ခွင့်ပြုချက်စောင့်",
            disabled: false,
          },
          {
            label: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
            value: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
            disabled: false,
          },
        ];
      } else if (this.status == "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "ခွင့်ပြုချက်စောင့်",
            value: "ခွင့်ပြုချက်စောင့်",
            disabled: true,
          },
          {
            label: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
            value: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
            disabled: false,
          },
          {
            label: "ကုန်ပစ္စည်းရောက်ရှိမှု",
            value: "ကုန်ပစ္စည်းရောက်ရှိမှု",
            disabled: false,
          },
        ];
      } else if (this.status == "တင်ဒါခေါ်ယူထားရှိမှု") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "တင်ဒါခေါ်ယူထားရှိမှု",
            value: "တင်ဒါခေါ်ယူထားရှိမှု",
            disabled: false,
          },
          {
            label: "တင်ဒါစိစစ်ပြီးစီးမှု",
            value: "တင်ဒါစိစစ်ပြီးစီးမှု",
            disabled: false,
          },
        ];
      } else if (this.status == "တင်ဒါစိစစ်ပြီးစီးမှု") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "တင်ဒါခေါ်ယူထားရှိမှု",
            value: "တင်ဒါခေါ်ယူထားရှိမှု",
            disabled: true,
          },
          {
            label: "တင်ဒါစိစစ်ပြီးစီးမှု",
            value: "တင်ဒါစိစစ်ပြီးစီးမှု",
            disabled: false,
          },
          {
            label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            disabled: false,
          },
        ];
      } else if (this.status == "စာချုပ်ပြီးပစ္စည်းစောင့်") {
        if (
          purchaseType == "သန်း၂၀အောက်စက်ပစ္စည်းအခြားဝယ်ကော်" ||
          purchaseType == "သန်း၂၀နှင့်၂၀၀ကြားစက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "သန်း၂၀၀အထက်စက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "ဝယ်ကော်" ||
          purchaseType == "တင်ဒါပြည်တွင်း"
        ) {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: false,
            },
            { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်", disabled: false },
          ];
        } else {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: false,
            },
            {
              label: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              value: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              disabled: false,
            },
          ];
        }
      } else if (this.status == "ဖွင့်ဖောက်") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "တင်ဒါခေါ်ယူထားရှိမှု",
            value: "တင်ဒါခေါ်ယူထားရှိမှု",
            disabled: true,
          },
          {
            label: "တင်ဒါစိစစ်ပြီးစီးမှု",
            value: "တင်ဒါစိစစ်ပြီးစီးမှု",
            disabled: true,
          },
          {
            label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            disabled: true,
          },
          { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်", disabled: false },
          { label: "FAC", value: "FAC", disabled: false },
        ];
      } else if (this.status == "စာချုပ်ပြီးလုပ်ငန်းစတင်") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "တင်ဒါခေါ်ယူထားရှိမှု",
            value: "တင်ဒါခေါ်ယူထားရှိမှု",
            disabled: true,
          },
          {
            label: "တင်ဒါစိစစ်ပြီးစီးမှု",
            value: "တင်ဒါစိစစ်ပြီးစီးမှု",
            disabled: true,
          },
          {
            label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            disabled: true,
          },
          {
            label: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
            value: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
            disabled: false,
          },
          {
            label: "PROGRESS_PERCENT",
            value: "PROGRESS_PERCENT",
            disabled: false,
          },
        ];
      } else if (this.status == "PROGRESS_PERCENT") {
        return [
          { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
          {
            label: "တင်ဒါခေါ်ယူထားရှိမှု",
            value: "တင်ဒါခေါ်ယူထားရှိမှု",
            disabled: true,
          },
          {
            label: "တင်ဒါစိစစ်ပြီးစီးမှု",
            value: "တင်ဒါစိစစ်ပြီးစီးမှု",
            disabled: true,
          },
          {
            label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
            disabled: true,
          },
          {
            label: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
            value: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
            disabled: true,
          },
          {
            label: "PROGRESS_PERCENT",
            value: "PROGRESS_PERCENT",
            disabled: false,
          },
          { label: "FAC", value: "FAC", disabled: false },
        ];
      } else if (this.status == "FAC") {
        if (
          purchaseType == "သန်း၂၀အောက်စက်ပစ္စည်းအခြားဝယ်ကော်" ||
          purchaseType == "သန်း၂၀နှင့်၂၀၀ကြားစက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "သန်း၂၀၀အထက်စက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "ဝယ်ကော်" ||
          purchaseType == "တင်ဒါပြည်တွင်း"
        ) {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်", disabled: true },
            { label: "FAC", value: "FAC", disabled: false },
            {
              label: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              value: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              disabled: false,
            },
          ];
        } else {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              value: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              disabled: true,
            },
            {
              label: "PROGRESS_PERCENT",
              value: "PROGRESS_PERCENT",
              disabled: true,
            },
            { label: "FAC", value: "FAC", disabled: false },
            {
              label: "ဝယ်ယူပြီးစီးမှု",
              value: "ဝယ်ယူပြီးစီးမှု",
              disabled: false,
            },
          ];
        }
      } else if (this.status == "ကုန်ပစ္စည်းရောက်ရှိမှု") {
        if (purchaseType == "စက်ရုံBOD" || purchaseType == "ရုံးချုပ်BOD") {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "ခွင့်ပြုချက်စောင့်",
              value: "ခွင့်ပြုချက်စောင့်",
              disabled: true,
            },
            {
              label: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
              value: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            {
              label: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              value: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              disabled: false,
            },
            {
              label: "ဝယ်ယူပြီးစီးမှု",
              value: "ဝယ်ယူပြီးစီးမှု",
              disabled: false,
            },
          ];
        } else {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်", disabled: true },
            { label: "FAC", value: "FAC", disabled: true },
            {
              label: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              value: "ကုန်ပစ္စည်းရောက်ရှိမှု",
              disabled: false,
            },
            {
              label: "ဝယ်ယူပြီးစီးမှု",
              value: "ဝယ်ယူပြီးစီးမှု",
              disabled: false,
            },
          ];
        }
      } else if (this.status == "ဝယ်ယူပြီးစီးမှု") {
        if (
          purchaseType == "သန်း၂၀အောက်စက်ပစ္စည်းအခြားဝယ်ကော်" ||
          purchaseType == "သန်း၂၀နှင့်၂၀၀ကြားစက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "သန်း၂၀၀အထက်စက်ပစ္စည်းအခြားတင်ဒါ" ||
          purchaseType == "ဝယ်ကော်" ||
          purchaseType == "တင်ဒါပြည်တွင်း"
        ) {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်", disabled: true },
            { label: "FAC", value: "FAC", disabled: true },
            { label: "ကုန်ပစ္စည်းရောက်ရှိမှု", value: "FAC", disabled: true },
            {
              label: "ဝယ်ယူပြီးစီးမှု",
              value: "ဝယ်ယူပြီးစီးမှု",
              disabled: true,
            },
          ];
        } else {
          return [
            { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်", disabled: true },
            {
              label: "တင်ဒါခေါ်ယူထားရှိမှု",
              value: "တင်ဒါခေါ်ယူထားရှိမှု",
              disabled: true,
            },
            {
              label: "တင်ဒါစိစစ်ပြီးစီးမှု",
              value: "တင်ဒါစိစစ်ပြီးစီးမှု",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              value: "စာချုပ်ပြီးပစ္စည်းစောင့်",
              disabled: true,
            },
            {
              label: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              value: "စာချုပ်ပြီးလုပ်ငန်းစတင်",
              disabled: true,
            },
            {
              label: "PROGRESS_PERCENT",
              value: "PROGRESS_PERCENT",
              disabled: true,
            },
            { label: "FAC", value: "FAC", disabled: true },
            {
              label: "ဝယ်ယူပြီးစီးမှု",
              value: "ဝယ်ယူပြီးစီးမှု",
              disabled: true,
            },
          ];
        }
      }
    },
    checkDisabled(checkType) {
      if (checkType == "finish") {
        if (this.status == "ဝယ်ယူပြီးစီးမှု") return true;
        else false;
      } else if (checkType == "pending") {
        if (
          this.status == "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်" ||
          this.status == "စာချုပ်ပြီးပစ္စည်းစောင့်" ||
          this.status == "ဖွင့်ဖောက်" ||
          this.status == "FAC" ||
          this.status == "ကုန်ပစ္စည်းရောက်ရှိမှု" ||
          this.status == "စာချုပ်ပြီးလုပ်ငန်းစတင်" ||
          this.status == "PROGRESS_PERCENT" ||
          this.status == "ဝယ်ယူပြီးစီးမှု"
        )
          return true;
        else false;
      } else false;
    },
    setProcurementPlan(plan) {
      this.purchaseOrder.procurementPlanNo = plan.issueNo;
      this.purchaseOrder.procurementPlanId = plan.id;
      this.purchaseOrder.orderYear = plan.planYear;
      if (plan.type != "Other") {
        this.purchaseOrder.purchaseType = plan.type;
      }
      this.showPlanListDialog = !this.showPlanListDialog;
    },
    changeAssetUnitCost(assetItem) {
      assetItem.unitCost = assetItem.actualUnitCost;
      assetItem.unitCostMMK = assetItem.unitCost * assetItem.exchangeRate;
      assetItem.unitCostMMK = Number(
        parseFloat(assetItem.unitCostMMK).toFixed(6)
      );
    },
  },
};
</script>
